module.exports = "<div>\n  logging out...\n</div>\n"